import { render } from "./AccordionItem.vue?vue&type=template&id=7e638a5d"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import "./AccordionItem.vue?vue&type=style&index=0&id=7e638a5d&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__